import React, { Component } from 'react';
//import { NavLink } from "react-router-dom"
import { authentication } from '../services/Authentication';

import { config } from '../Constants';
import helpers from '../Function';
import moment from 'moment';
import Modal from "react-bootstrap/Modal";
import ModalBody from "react-bootstrap/ModalBody";
import ModalHeader from "react-bootstrap/ModalHeader";
import ModalFooter from "react-bootstrap/ModalFooter";
import ModalTitle from "react-bootstrap/ModalTitle";
import CircularProgress from '@material-ui/core/CircularProgress';

import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import TablePagination from '@material-ui/core/TablePagination';

import Checkbox from '@material-ui/core/Checkbox';
import $ from "jquery";
import ReactExport from "react-export-excel";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Editor } from '@tinymce/tinymce-react';
import Select from 'react-select';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

export default class Point extends Component {

    componentDidMount() {
        helpers.checklogin(this.state.jwt);
    }

    constructor(props) {
        super(props);
        const { name, user_id, user_type, jwt, user_permission } = authentication.currentUserValue;

        this.state = {
            apiKey: process.env.TINY,
            userid: user_id,
            jwt: jwt,
            user_permission: user_permission,
            pages: [],
            category_pages: [],
            level_pages: [],
            addIsOpen: false,
            srcIsOpen: false,
            deleteIsOpen: false,
            updateIsOpen: false,
            warningIsOpen: false,
            content_id: '',
            warningMessage: "",
            methodOpen: '',
            spinner: true,
            spinnerres: true,

            //Take
            xtid:"",
            transfer_preview:"",
            transfer_name_th:"",
            transfer_name_en:"",
            member_id:"",
            member_email:"",
            member_name:"",
            member_idcard:"",
            member_phone:"",
            point_balance:"",
            point_use:"",
            transfer_point_earn:"",
            transfer_point_balance:"",
            earn_unit:"",
            reference_1_title:"",
            reference_2_title:"",
            reference_3_title:"",
            reference_1_value:"",
            reference_2_value:"",
            reference_3_value:"",
            transaction_id:"",
            transfer_status:"",
            transfer_date:"",
            src_reference:"",
            src_status:"",

            //Take

            add_id: '',
            add_name_th: '',
            add_name_en: '',
            src_name_th: '',
            src_name_en: '',
            add_category: null,
            add_content: '',
            add_level: '',
            add_point: '',
            add_active_status: '',
            add_img: '',
            add_no: '',
            add_start_date: '',
            add_end_date: '',
            active: true,
            create_by: name,
            create_by_id: user_id,
            usertype: user_type,
            src_active: false,
            src_nonactive: false,
            file: null,
            page: 0,
            rowsPerPage: 10,
            miss_su: helpers.getUserType(user_type, "su"),
        };

        $("#root").addClass("wrapper");
        $("body").removeClass("login-page");

        this.closeAdd = this.closeAdd.bind(this);
        // this.openAdd = this.openAdd.bind(this);
        // this.submitAdd = this.submitAdd.bind(this);

        // this.openEdit = this.openEdit.bind(this);
        this.openView = this.openView.bind(this);

        this.change = this.change.bind(this);
        this.dataTable = this.dataTable.bind(this);
        // this.submitEdit = this.submitEdit.bind(this);

        this.closeSrc = this.closeSrc.bind(this);
        this.openSrc = this.openSrc.bind(this);
        this.submitSrc = this.submitSrc.bind(this);

        this.handleCheck = this.handleCheck.bind(this)

        // this.openDelete = this.openDelete.bind(this);
        // this.closeDelete = this.closeDelete.bind(this);
        // this.submitDelete = this.submitDelete.bind(this);

        this.onChange = this.onChange.bind(this);
        this.handleChangePage = this.handleChangePage.bind(this);
        this.levelChange = this.levelChange.bind(this)
        this.closeModelUpdate = this.closeModelUpdate.bind(this);

        this.handleActiveSrcCheck = this.handleActiveSrcCheck.bind(this)
        this.handleNonActiveSrcCheck = this.handleNonActiveSrcCheck.bind(this)
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);

        this.closeWarning = this.closeWarning.bind(this);
        this.cateLevel = this.cateLevel.bind(this);
        this.dataTable();
        this.cateLevel();
    }

    cateLevel () {
        try {
            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
    
            fetch(config.url.API_URL + '/category_points', requestOptions)
                .then(res => res.json())
                .then(data => {
                    let FromApi = data.data.map(dataMain => {
                        return { value: dataMain._id, label: dataMain.name_th }
                    });
                    this.setState({
                        category_pages: FromApi
                    });
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                });
    
            fetch(config.url.API_URL + '/level_members/', requestOptions)
                .then(res => res.json())
                .then(data => {
                    let FromApi = data.data.map(dataMain => {
                        return { value: dataMain._id, label: dataMain.name_th }
                    });
                    this.setState({
                        level_pages: FromApi
                    });
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    handleChangeRowsPerPage(event) {
        //alert(event.target.value)
        this.setState({
            page: 0,
            rowsPerPage: parseInt(event.target.value)
        });
    };

    dataTable() {
        try {
            this.setState({spinner:true})
            const requestOptions = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
    
            const queryParams = new URLSearchParams({ reference: this.state.src_reference }).toString();
            fetch(config.url.API_URL + '/transfer-history?' + queryParams, requestOptions)
                .then(res => res.json())
                .then(data => {
                    console.log(data.data)
                    if (Array.isArray(data.data) && data.data.length) {
                        this.setState({
                            pages: [].concat(data.data),
                            spinner: false
                        });
                    } else {
                        this.setState({
                            pages: [],
                            spinner: false
                        });
                    }
    
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    submitSrc(e) {
        this.dataTable()
        this.setState({ srcIsOpen: false , src_reference : ''});
    }

    openAdd() {
        this.setState({
            addIsOpen: true,
            methodOpen: 'add',
            add_name_th: '',
            add_name_en: '',
            add_category: null,
            add_content: '',
            add_start_date: '',
            add_end_date: '',
            add_level: null,
            add_point: '',
            add_no: '',
            add_active_status: true
        });
    }

    openView(e) {
        try {
            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
    
            fetch(config.url.API_URL + '/transfer-history/'+ e.currentTarget.attributes["data-id"].value, requestOptions)
                .then(res => res.json())
                .then(dataMain => {
                    var data = dataMain.data;
                    console.log(data)
                    this.setState({
                        xtid: data.XTID,
                        transfer_preview: data.transfer_img,
                        transfer_name_th: data.transfer_name_th,
                        transfer_name_en: data.transfer_name_en,
                        member_id: data.member_id,
                        member_email:data.member_email,
                        member_name:data.member_name,
                        member_idcard:data.member_idcard,
                        member_phone:data.member_phone,
                        point_balance:data.pf_point_balance,
                        point_use:data.used_pf_point,
                        transfer_point_earn:data.transfer_point_earn,
                        transfer_point_balance: data.transfer_point_balance,
                        earn_unit:data.transfer_unit,
                        reference_1_title:data.reference_1_title,
                        reference_2_title:data.reference_2_title,
                        reference_3_title:data.reference_3_title,
                        reference_1_value:data.reference_1_value,
                        reference_2_value:data.reference_2_value,
                        reference_3_value:data.reference_3_value,
                        transaction_id:data.transactionID,
                        transfer_status:data.transfer_status,
                        transfer_date:data.created,
                        // updated:data.updated,
                    })
    
                    let category = "";
                    let level = ""
                    for(var i=0;i<data.categorys.length;i++){
                        category += (category?", "+data.categorys[i].name_th:data.categorys[i].name_th);
                    }
                    for(var i=0;i<data.level_members.length;i++){
                        level += (level?", "+data.level_members[i].name_th:data.level_members[i].name_th);
                    }
                    
                    this.setState({
                        category_name: category,
                        level_name:level,
                        addIsOpen: true,
                        methodOpen: 'view'
                    });
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    closeWarning() {
        this.setState({ warningIsOpen: false });
        this.dataTable();
    }

    closeAdd() {
        this.setState({
            add_id: '',
            add_name: '',
            add_name_en: '',
            add_category: null,
            add_content: '',
            add_start_date: '',
            add_end_date: '',
            add_level: '',
            add_point: '',
            add_amount: '',
            add_no: '',
            file: null
        });
        this.setState({ addIsOpen: false });
    }

    closeSrc() {
        this.setState({ srcIsOpen: false });
    }

    closeModelUpdate() {
        this.setState({ updateIsOpen: false });
        this.dataTable();
    }

    openSrc(e) {
        this.setState({
            srcIsOpen: true,
            src_active: false,
            src_nonactive: false,
            src_name_th: '',
            src_name_en:'',
            add_name_th: '',
            add_name_en: '',
            add_category: null,
            add_content: '',
            add_start_date: '',
            add_end_date: '',
            add_level: '',
            add_point: '',
            add_amount: '',
            add_no: '',
            page: 0
        });
    }

    change(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    onChange(e) {
        this.setState({ file: e.target.files[0] });
    }

    handleCheck() {
        this.setState({ active: !this.state.active });
    }

    handleChangePage(event, newPage) {
        this.setState({
            page: newPage
        });
    };

    handleActiveSrcCheck() {
        this.setState({
            src_active: !this.state.src_active
        });
    }

    handleNonActiveSrcCheck() {
        this.setState({
            src_nonactive: !this.state.src_nonactive
        });
    }

    changeStartDate = date => {
        this.setState({
            add_start_date: date
        });
    }

    changeEndDate = date => {
        this.setState({
            add_end_date: date
        });
    }

    handleEditorChange = (content, editor) => {
        this.setState({
            add_content: content
        });
        console.log('Content was updated:', content);
    }

    handleChange = add_category => {
        this.setState(
            { add_category },
            () => console.log(`Option selected:`, this.state.add_category)
        );
    };

    levelChange = add_level => {
        this.setState(
            { add_level },
            () => console.log(`Option selected:`, this.state.add_level)
        );
    };

    render() {
        const StyledTableCell = withStyles(theme => ({
            head: {
                backgroundColor: "#E8EFF5",
                color: "#212529",
                fontSize: 20,
                fontFamily: 'db_heaventmed_cond',
                border: '1px solid rgba(224, 224, 224, 1)',
                textAlign: 'center',
            },
            body: {
                fontSize: 18,
                verticalAlign: 'text-top',
                fontFamily: 'db_heaventmed_cond',
                border: '1px solid rgba(224, 224, 224, 1)',
                padding: 8,
            },
        }))(TableCell);

        const StyledTableRow = withStyles(theme => ({
            root: {
                '&:nth-of-type(odd)': {
                    backgroundColor: theme.palette.background.default,
                },
            },
        }))(TableRow);

        const emptyRows = this.state.rowsPerPage - Math.min(this.state.rowsPerPage, this.state.page.length - this.state.page * this.state.rowsPerPage);

        return (
            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1 className="m-0 text-dark">Transfer Points List</h1>
                            </div>{/* /.col */}
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                                    <li className="breadcrumb-item active">Transfer Points</li>
                                </ol>
                            </div>{/* /.col */}
                        </div>{/* /.row */}
                    </div>{/* /.container-fluid */}
                </div>
                {/* /.content-header */}
                {/* Main content */}
                <section className="content">
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    <div className="btn-advance text-center" onClick={this.openSrc}>ค้นหาขั้นสูง</div>
                                    {/* <ExcelFile filename="home_type" element={(this.state.user_permission[225].permission == 1 &&
                                        <div className="btn-add text-center">Export Data</div>
                                    )}>
                                        <ExcelSheet data={this.state.pages} name="home_type">
                                            <ExcelColumn label="ชื่อไทย" value="name_th" />
                                            <ExcelColumn label="ชื่ออังกฤษ" value={(col) => col.name_en} />
                                            <ExcelColumn label="อัพเดทล่าสุด" value={(col) => col.updateby} />
                                            <ExcelColumn label="อัพเดทล่าสุด(วันที่)" value={(col) => col.updated} />
                                        </ExcelSheet>
                                    </ExcelFile> */}
                                    {/* {(this.state.user_permission[24].permission == 1 &&
                                        <div className="btn-add text-center" onClick={this.openAdd}>เพิ่มข้อมูล</div>
                                    )} */}
                                </div>
                                {/* .card-header */}
                                {
                                        this.state.spinner && <div style={{ textAlign: 'center' }}><CircularProgress /></div>
                                    }
                                    {
                                        !this.state.spinner && 
                                <div className="card-body">
                                    <TableContainer component={Paper}>
                                        <Table aria-label="simple table">
                                            <TableHead>
                                                <TableRow>
                                                    <StyledTableCell style={{ width: 'auto' }}>Preview</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>แลกคะแนน</StyledTableCell>
                                                    {/* <StyledTableCell style={{ width: 'auto' }}>หมวดหมู่</StyledTableCell> */}
                                                    <StyledTableCell style={{ width: 'auto' }}>Transaction ID</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>Partner Code</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>คะแนนที่ใช้</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>พอยท์ที่ได้รับ</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>คะแนนคงเหลือ</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>Reference</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>วันที่สร้าง</StyledTableCell>
                                                    <StyledTableCell style={{ width: '100px' }}>สถานะ</StyledTableCell>
                                                    {/* <StyledTableCell style={{ width: '100px' }}>อัพเดตล่าสุด</StyledTableCell> */}
                                                    <StyledTableCell style={{ width: '100px' }}>รายละเอียด</StyledTableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody style={{textAlignLast:'center'}}>
                                                {
                                                    this.state.pages.slice(this.state.page * this.state.rowsPerPage,
                                                        this.state.page * this.state.rowsPerPage + this.state.rowsPerPage).map((data, i) => {
                                                            return (
                                                                <StyledTableRow key={`1${i}`}>
                                                                    <StyledTableCell><img src={data.transfer_img} width="100px" height="auto"/></StyledTableCell>
                                                                    <StyledTableCell style={{ width: 'auto' }}>{data.transfer_name_th}</StyledTableCell>
                                                                    {/* <StyledTableCell>{(data.categorys != undefined && data.categorys.length > 0?data.categorys.map((data,i) => { return (i>0?", ":"")+data.name_th}):"")}</StyledTableCell> */}
                                                                    <StyledTableCell style={{ width: 'auto' }}>{data.transactionID.toUpperCase()}</StyledTableCell>
                                                                    <StyledTableCell style={{ width: 'auto' }}>{data.member_id}</StyledTableCell>
                                                                    <StyledTableCell>{data.used_pf_point + " PF Point"}</StyledTableCell>
                                                                    <StyledTableCell>{data.transfer_point_earn + " " + data.transfer_unit}</StyledTableCell>
                                                                    <StyledTableCell>{data.pf_point_balance + " PF Point"}</StyledTableCell>
                                                                    <StyledTableCell>
                                                                        {data.reference_1_title != "" && data.reference_1_value != "" ? data.reference_1_title + " : " + data.reference_1_value : ""}
                                                                        {data.reference_2_title != "" && data.reference_2_value != "" ? data.reference_2_title + " : " + data.reference_2_value : ""}
                                                                        {data.reference_3_title != "" && data.reference_3_value != "" ? data.reference_3_title + " : " + data.reference_3_value : ""}
                                                                    </StyledTableCell>
                                                                    <StyledTableCell>{moment(data.created).format('DD/MM/YYYY h:mm น.')}</StyledTableCell>
                                                                    <StyledTableCell style={{color: helpers.getTransferStatusColor(data.transfer_status)}}>{helpers.getTransferStatus(data.transfer_status)}</StyledTableCell>
                                                                    {/* <StyledTableCell>{data.updated != undefined ? moment(data.updated).format('DD/MM/YYYY h:mm น.') : ""}</StyledTableCell> */}
                                                                    <StyledTableCell>
                                                                        <button className="btn-action text-center" data-id={data._id} onClick={this.openView}><img src="dist/img/icon/ic_view.png" className="btn-icon" alt="" />View</button>
                                                                    </StyledTableCell>
                                                                </StyledTableRow>)
                                                        })
                                                }

                                                {emptyRows > 0 && (
                                                    <StyledTableRow>
                                                        <StyledTableCell colSpan={6} />
                                                    </StyledTableRow>
                                                )}
                                            </TableBody>
                                        </Table>
                                        <TablePagination
                                            rowsPerPageOptions={[10, 25, 50]}
                                            component="div"
                                            count={this.state.pages.length}
                                            rowsPerPage={this.state.rowsPerPage}
                                            page={this.state.page}
                                            onChangePage={this.handleChangePage}
                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                        />
                                    </TableContainer>
                                </div>
                                }
                                {/* /.card-body */}
                            </div>
                            {/* /.card */}
                        </div>
                        {/* /.col */}
                    </div>
                    {/* /.row */}
                </section>
                {/* /.content */}
                <Modal show={this.state.srcIsOpen} onHide={this.closeSrc} size="lg">
                    <ModalHeader>
                        <ModalTitle>ค้นหาขั้นสูง</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        <form id="form-serach">
                            <div className="row mb-12">
                                <div className="col-sm-2 text-right">Reference</div>
                                <div className="col-sm-8">
                                    <input type="text" className="form-control" id="src_reference" name="src_reference" onChange={this.change} />
                                </div>
                            </div>
                            {/* <div className="row mb-3">
                                <div className="col-sm-2 text-right">ชื่ออังกฤษ</div>
                                <div className="col-sm-6">
                                    <input type="text" className="form-control" id="src_name_en" name="src_name_en" onChange={this.change} />
                                </div>
                            </div> */}
                            {/* <div className="row mb-3" >
                                <div className="col-sm-2 text-right">สถานะ</div>
                                <div className="col-sm-6">
                                    <Checkbox
                                        checked={this.state.src_active}
                                        onChange={this.handleActiveSrcCheck}
                                        color="primary"
                                    /> ใช้งาน
                                    <Checkbox
                                        checked={this.state.src_nonactive}
                                        onChange={this.handleNonActiveSrcCheck}
                                        color="primary"
                                    /> ไม่ได้ใช้งาน
                                </div>
                            </div> */}
                        </form>
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-danger" onClick={this.closeSrc}>ยกเลิก</button>&nbsp;&nbsp;
                        <button className="btn btn-success" onClick={this.submitSrc}>ค้นหาข้อมูล</button>
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.addIsOpen} onHide={this.closeAdd} size="xl">
                    <ModalHeader>
                        <ModalTitle>{(this.state.methodOpen === 'view' && "ตรวจสอบข้อมูล")}</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        <form id="form-submit">
                            <div className="row mb-3">
                                <div className="col-sm-2 text-right">Preview<span style={{ color: 'red' }}>*</span></div>
                                <div className="col-sm-9">
                                    <img src={this.state.transfer_preview} alt="pic" height="200" width="auto" />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-2 text-right align-self-center">ชื่อไทย<span style={{ color: 'red' }}>*</span></div>
                                <div className="col-sm-3">
                                    <TextareaAutosize type="text" className="form-control" id="add_name_th" name="add_name_th" defaultValue={this.state.transfer_name_th} readOnly />
                                </div>
                                <div className="col-sm-2 text-right align-self-center">ชื่ออังกฤษ<span style={{ color: 'red' }}>*</span></div>
                                <div className="col-sm-3">
                                    <TextareaAutosize type="text" className="form-control" id="add_name_en" name="add_name_en" defaultValue={this.state.transfer_name_en} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                            <div className='col-sm-6'>
                                    <h4 className='px-5'>รายละเอียด</h4>
                                    <div className='row'>
                                        <div className='col-sm-3 text-right mb-3' style={{alignSelf: 'center'}}>ชื่อผู้ใช้</div>
                                        <div className='col-sm-7 mb-3'>
                                            <input defaultValue={this.state.member_name} disabled type="text" className="form-control" id="fgf_id" name="fgf_id"/>
                                        </div>

                                        <div className='col-sm-3 text-right mb-3' style={{alignSelf: 'center'}}>เลขประจำตัวประชาชน</div>
                                        <div className='col-sm-7 mb-3'>
                                            <input defaultValue={this.state.member_idcard} disabled type="text" className="form-control" id="fgf_id" name="fgf_id"/>
                                        </div>

                                        <div className='col-sm-3 text-right mb-3' style={{alignSelf: 'center'}}>Reference 1 </div>
                                        <div className='col-sm-7 mb-3'>
                                            <input defaultValue={this.state.reference_1_title ? this.state.reference_1_title +" : "+this.state.reference_1_value : ""} disabled type="text" className="form-control" id="fgf_title" name="fgf_title"/>
                                        </div>

                                        <div className='col-sm-3 text-right mb-3' style={{alignSelf: 'center'}}>Reference 2 </div>
                                        <div className='col-sm-7 mb-3'>
                                            <input defaultValue={this.state.reference_2_title ? this.state.reference_2_title +" : "+this.state.reference_2_value : ""} disabled type="text" className="form-control" id="fgf_title" name="fgf_title"/>
                                        </div>

                                        <div className='col-sm-3 text-right mb-3' style={{alignSelf: 'center'}}>Reference 3 </div>
                                        <div className='col-sm-7 mb-3'>
                                            <input defaultValue={this.state.reference_3_title ? this.state.reference_3_title +" : "+this.state.reference_3_value : ""} disabled type="text" className="form-control" id="fgf_title" name="fgf_title"/>
                                        </div>

                                    </div>
                                </div>
                                <div className='col-sm-6'>
                                    <h4>ข้อมูลการแลกคะแนน</h4>
                                    <div className='row'>
                                        <div className='col-sm-3 text-right mb-3' style={{alignSelf: 'center'}}>Partner Code</div>
                                        <div className='col-sm-7 mb-3'>
                                            <input defaultValue={this.state.member_id} disabled type="text" className="form-control" id="fgf_customer_name" name="fgf_customer_name"/>
                                        </div>

                                        <div className='col-sm-3 text-right mb-3' style={{alignSelf: 'center'}}>Transaction ID</div>
                                        <div className='col-sm-7 mb-3'>
                                            <input defaultValue={this.state.transaction_id} disabled type="text" className="form-control" id="fgf_customer_name" name="fgf_customer_name"/>
                                        </div>

                                        <div className='col-sm-3 text-right mb-3' style={{alignSelf: 'center'}}>คะแนนที่ใช้ (PF Point)</div>
                                        <div className='col-sm-7 mb-3'>
                                            <input defaultValue={this.state.point_use} disabled type="text" className="form-control" id="fgf_customer_name" name="fgf_customer_name"/>
                                        </div>

                                        <div className='col-sm-3 text-right mb-3' style={{alignSelf: 'center'}}>คะแนนที่ได้รับ</div>
                                        <div className='col-sm-7 mb-3'>
                                            <input defaultValue={this.state.transfer_point_earn + " " + this.state.earn_unit} disabled type="text" className="form-control" id="fgf_customer_phone" name="fgf_customer_phone"/>
                                        </div>

                                        <div className='col-sm-3 text-right mb-3' style={{alignSelf: 'center'}}>{this.state.earn_unit + " คงเหลือ"}</div>
                                        <div className='col-sm-7 mb-3'>
                                            <input defaultValue={this.state.transfer_point_balance ? this.state.transfer_point_balance + " " + this.state.earn_unit : ""} disabled type="text" className="form-control" id="fgf_customer_email" name="fgf_customer_email"/>
                                        </div>

                                        <div className='col-sm-3 text-right mb-3' style={{alignSelf: 'center'}}>คะแนนคงเหลือ (PF Point)</div>
                                        <div className='col-sm-7 mb-3'>
                                            <input defaultValue={this.state.point_balance ? this.state.point_balance + " PF Point" : ""} disabled type="text" className="form-control" id="fgf_project_name" name="fgf_project_name"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-2 text-right">ระดับสมาชิก<span style={{ color: 'red' }}>*</span> :</div>
                                <div className="col-sm-6">
                                    <TextareaAutosize className='form-control' name='add_level' rowsMin={1} defaultValue={this.state.level_name} disabled />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className='col-sm-2 text-right'>หมวดหมู่<span style={{ color: 'red' }}>*</span></div>
                                    <div className='col-sm-6'>
                                        {(this.state.methodOpen === 'add') || (this.state.methodOpen === 'edit') ?
                                            (<Select
                                                value={this.state.add_category}
                                                onChange={this.handleChange}
                                                options={this.state.category_pages}
                                                isMulti
                                                isSearchable
                                            />)
                                            : (<TextareaAutosize className='form-control' name='add_category' rowsMin={1} defaultValue={this.state.category_name} disabled />)
                                        }
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-2 text-right">วันที่ทำรายการ</div>
                                <div className="col-sm-6">
                                <div className="form-control">{moment(this.state.transfer_date).format("DD/MM/YYYY HH:mm:ss")}</div>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-2 text-right">สถานะ<span style={{ color: 'red' }}>*</span></div>
                                <div className="col-sm-6">
                                    <div>
                                        <p style={{color: helpers.getTransferStatusColor(this.state.transfer_status)}}>{helpers.getTransferStatus(this.state.transfer_status)}</p>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </ModalBody>
                    <ModalFooter>
                        <div><button className="btn btn-success" onClick={this.closeAdd}>ตกลง</button></div>
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.updateIsOpen} onHide={this.closeModelUpdate} size="s">
                    <ModalHeader>
                        <ModalTitle>แจ้งเตือน</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        บันทึกรายการสำเร็จ
                        </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-success" onClick={this.closeModelUpdate}>ตกลง</button>
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.deleteIsOpen} onHide={this.closeDelete} size="s">
                    <ModalHeader>
                        <ModalTitle>แจ้งเตือน</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        ยืนยันการลบรายการหรือไม่
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-danger" onClick={this.closeDelete}>ยกเลิก</button>&nbsp;&nbsp;
                        <button className="btn btn-warning" onClick={this.submitDelete}>ยืนยัน</button>
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.warningIsOpen} onHide={this.closeWarning} size="s">
                    <ModalHeader>
                        <ModalTitle>แจ้งเตือน</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        {this.state.warningMessage}
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-danger" onClick={this.closeWarning}>ยกเลิก</button>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}